import { render, staticRenderFns } from "./gradeAdmin.vue?vue&type=template&id=6efdbc60&scoped=true"
import script from "./gradeAdmin.vue?vue&type=script&lang=js"
export * from "./gradeAdmin.vue?vue&type=script&lang=js"
import style0 from "./gradeAdmin.vue?vue&type=style&index=0&id=6efdbc60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efdbc60",
  null
  
)

export default component.exports